import { useState, useCallback, useMemo, useEffect } from "react"
import styles from "./index.module.scss"
import PicViewerLeft from "./PicViewerLeft"
import PicViewerRight from "./PicViewerRight"
import PicViewerCenter from "./PicViewerCenter"
import { message } from "antd"

const IMAGE_STATUS = {
    SUBMIT: 0, // 已修图
    NEED_REFINE: 1, // 待修图
    PASS: 2, // 已通过
    CANCEL: -1, // 已取消
}

// const mockData = Array(20).fill(0).map((_, index) => ({
//     id: "xxxxx",
//     name: "结果图",
//     url: `https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-01-16/1768542664905330368_22073.jpg?${index}`,
//     status: 'approved', // 'approved' | 'rejected' | 'modified' | undefined
//     annotations: [],
//     annotationHistory: [],
//     title: '商品货号',
//     extraInfos: [],
//     extraImages: [
//         { label: '商品图', url: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-01-16/1768542664905330368_22073.jpg" },
//         { label: '搭配图', url: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-01-16/1768542664905330368_22073.jpg" },
//         { label: '参考图', url: "https://photostudio-qa.oss-cn-hangzhou.aliyuncs.com/aigc/temp/2026-01-16/1768542664905330368_22073.jpg" },
//     ],
// }))

export default function PictureViewer (props) {
    const {
        mode = 0, // 0单画布 1双画布
        showModeChanger = false, // 是否显示画布模式切换器
        defaultImages = [],
        defaultIndex = 0,
        onStatusChange,
        onFeedback,
        onCancel,
        rightSideRender = null,
    } = props
    const [images, setImages] = useState(defaultImages)
    const [currentIndex, setCurrentIndex] = useState(defaultIndex)
    // 当前图片
    const currentImage = useMemo(() => images[currentIndex] || {}, [images, currentIndex])
    // 上一张图片
    const handlePrev = useCallback(() => {
        setCurrentIndex(prev => Math.max(0, prev - 1))
    }, [])
    // 下一张图片
    const handleNext = useCallback(() => {
        setCurrentIndex(prev => Math.min(images.length - 1, prev + 1))
    }, [images.length])
    // 选择图片
    const handleSelect = useCallback((index) => {
        setCurrentIndex(index)
    }, [])
    // 状态改变
    const handleStatusChange = useCallback(async (status, annotation) => {
        const id = currentImage.id
        await onStatusChange?.({id, status, annotation}, currentImage._raw)
        setImages(prev => {
            const newImages = [...prev]
            newImages[currentIndex] = {
                ...newImages[currentIndex],
                status,
                annotations: annotation ? [{ label: annotation, timestamp: Date.now() }] : []
            }
            return newImages
        })
    }, [currentIndex, currentImage])
    // 反馈改变
    const handleFeedbackChange = useCallback(async (like, feedbackText, feedbackId) => {
        const id = currentImage.id
        if (feedbackId) {
            await onFeedback?.({id, like, feedbackId, feedbackText}, currentImage._raw)
            setImages(prev => {
                const newImages = [...prev]
                newImages[currentIndex] = {
                    ...newImages[currentIndex],
                    feedback: {
                        id: feedbackId,
                        like: like ? 1 : 0,
                        description: feedbackText,
                    }
                }
                return newImages
            })
        } else {
            const feedbackId = await onFeedback?.({id, like, feedbackText}, currentImage._raw)
            setImages(prev => {
                const newImages = [...prev]
                newImages[currentIndex] = {
                    ...newImages[currentIndex],
                    feedback: {
                        id: feedbackId,
                        like: like ? 1 : 0,
                        description: feedbackText,
                    }
                }
                return newImages
            })
        }
    }, [currentIndex, currentImage])

    return (
        <div className={styles.PictureViewer}>
            <div className={styles.LeftWrapper}>
                <PicViewerLeft
                    onCancel={onCancel}
                    images={images}
                    currentIndex={currentIndex}
                    onSelect={handleSelect}
                />
            </div>
            <div className={styles.CenterWrapper}>
                <PicViewerCenter
                    image={currentImage}
                    mode={mode}
                    onPrev={handlePrev}
                    onNext={handleNext}
                    hasPrev={currentIndex > 0}
                    hasNext={currentIndex < images.length - 1}
                    onStatusChange={handleStatusChange}
                />
            </div>
            <div className={styles.RightWrapper} style={rightSideRender ? {width: '288px'} : {width: '215px'}}>
            {
                rightSideRender ?
                rightSideRender(currentImage) : null
            } {
                <PicViewerRight
                    image={currentImage}
                    onFeedback={handleFeedbackChange}
                />
            }
            </div>
        </div>
    )
}
